import { Button, Dialog, ErrorBoundary, Loader } from 'components/atoms'
import { useBoolean } from 'hooks'
import { FaCog } from 'react-icons/fa'
import { ProgramCreate } from './ProgramCreate'
import { useTranslation } from 'react-i18next'

export const ProgramAddButton: React.FC = () => {
  const [isModalOpen, toggleModal, closeModal] = useBoolean(false)
  const { t } = useTranslation()
  
  return (
    <div>
      <Button Icon={<FaCog/>} onClick={toggleModal} css={{ width: 'fit-content', whiteSpace: 'nowrap' }}>
        {t('lot.program.handleProgram')}
      </Button>
      <Dialog isOpen={isModalOpen} close={closeModal}>
        <h5>{t('lot.program.program')}</h5>
        <ProgramCreate />
      </Dialog>
    </div>
  )
}
